// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  companyLocations: [],
  totalCompanyLocations: 0,
}

export const mutations = {
  SET_COMPANY_LOCATIONS(state, companyLocations) {
    state.companyLocations = companyLocations
  },
  SET_TOTAL_COMPANY_LOCATIONS(state, total) {
    state.totalCompanyLocations = total
  },
  ADD_COMPANY_LOCATION(state, companyLocation) {
    state.companyLocations.push(companyLocation)
  },
  EDIT_COMPANY_LOCATION(state, companyLocation) {
    const index = state.companyLocations.findIndex(
      (el) => el.company_location_uuid === companyLocation.company_location_uuid
    )
    if (index !== -1) {
      state.companyLocations.splice(index, 1, companyLocation)
    }
  },
  DELETE_COMPANY_LOCATION(state, company_location_uuid) {
    const index = state.companyLocations.findIndex(
      (el) => el.company_location_uuid === company_location_uuid
    )
    if (index !== -1) state.companyLocations.splice(index, 1)
  },
}

export const actions = {
  fetchCompanyLocations({ commit }, payload) {
    return ApiService.fetchCompanyLocations(payload)
      .then((res) => {
        const { data, total } = res.data
        commit('SET_COMPANY_LOCATIONS', data)
        commit('SET_TOTAL_COMPANY_LOCATIONS', total)
      })
      .catch((error) => {
        throw error
      })
  },
  addCompanyLocation({ commit }, payload) {
    return ApiService.addCompanyLocation(payload)
      .then((res) => {
        const companyLocation = res.data
        commit('ADD_COMPANY_LOCATION', companyLocation)
      })
      .catch((error) => {
        throw error
      })
  },
  editCompanyLocation({ commit }, payload) {
    return ApiService.editCompanyLocation(payload)
      .then((res) => {
        const companyLocation = res.data
        commit('EDIT_COMPANY_LOCATION', companyLocation)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteCompanyLocation({ commit }, payload) {
    return ApiService.deleteCompanyLocation(payload)
      .then(() => {
        commit('DELETE_COMPANY_LOCATION', payload.company_location_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
}
